import { render, staticRenderFns } from "./ElderlyRelCommunity.vue?vue&type=template&id=3655f228&"
import script from "./ElderlyRelCommunity.vue?vue&type=script&lang=js&"
export * from "./ElderlyRelCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports